'use client';

import Grid from "@mui/material/Grid2";
import FlyoutHeaderTypography
    from "@/app/features/sites/header/ui/desktop/flyout-info/FlyoutHeaderTypography";
import { Box, Typography } from "@mui/material";
import { formatOpeningHoursShortText } from "@/app/features/sites/opening-hours/helper/text-presenter";
import SpecialOpeningHoursView from "@/app/__to_be_integrated/_____components/_NEW/opening-hours/SpecialOpeningHoursView";
import React, { useEffect } from "react";
import { OpeningHoursFlyoutContent } from "@/app/features/sites/header/ui/desktop/flyout-info/flyouts/types/types";
import { loadOpeningHoursFlyoutContent } from "@/app/features/sites/header/ui/desktop/flyout-info/flyouts/data-access/preload";
import FlyoutWrapper from "@/app/features/sites/header/ui/desktop/flyout-info/FlyoutWrapper";
import ErrorBox from "@/app/__to_be_integrated/_____components/_NEW/ErrorBox";

export default function OpeningHoursFlyoutInfo() {

    const [content, setContent] = React.useState<OpeningHoursFlyoutContent>();
    const [error, setError] = React.useState<string | null>(null);

    useEffect(() => {
        (async() => {
            const { data, error } = await loadOpeningHoursFlyoutContent();
            if (error || !data) {
                console.error('Error loading opening hours flyout content:', error);
                setError('Fehler beim Laden der Inhalte. Bitte versuchen Sie es später erneut.');
                return;
            }

            setContent(data);
        })()
    }, []);

    if (error) return <ErrorBox error={error} />
    if (content === undefined) return null;

    return (
        <FlyoutWrapper
            backgroundImage={content.slideOutOpeningHour.image}
            mobileScrollMode="none"
            slots={{
                paper: {
                    sx: {
                        display: 'flex',
                        height: { xs: '100%', md: 'calc(60vh - var(--header-height, 132px))' },
                        // width: '60vw',
                    }
                }
            }}
        >
            <Grid
                container
                columnSpacing={8}
                sx={{ flex: 1, minHeight: 0, maxHeight: '100%', height: '100%' }}
                className="overflow-hidden"
                direction={{ xs: 'column', md: 'row' }}
                wrap="nowrap"
            >
                <Grid
                    size={{ xs: 12, md: 4 }}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0,
                        maxHeight: '100%',
                        flexShrink: 0,
                    }}
                >
                    <FlyoutHeaderTypography>Öffnungszeiten</FlyoutHeaderTypography>
                    <Box
                        sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: 0 }}
                    >
                        <Typography variant="body2" textAlign="center">
                            {formatOpeningHoursShortText(content.generalOpeningHours)}
                        </Typography>
                    </Box>
                </Grid>
                <Grid
                    size={{ xs: 12, md: 8 }}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0,
                        maxHeight: '100%',
                        px: 2,
                        flex: 1,
                        overflow: 'hidden',
                    }}
                >
                    <FlyoutHeaderTypography>Sonderöffnungszeiten & Schließtage</FlyoutHeaderTypography>
                    <SpecialOpeningHoursView specialOpeningHours={content.specialOpeningHours} />
                </Grid>
            </Grid>
        </FlyoutWrapper>
    )
}
